import type { Locale } from "@/lib/i18n";
import { pl, type CDedicatedDescriptivePageTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cDedicatedDescriptivePageTranslations: Record<Locale, CDedicatedDescriptivePageTranslations> = {
  pl,
  en,
  de,
};

export type { CDedicatedDescriptivePageTranslations };
